/* eslint-disable */
import * as React from 'react';
import { useCalendarValue } from './hooks/useCalendarValue';
import { useCalendarMultiple } from './hooks/useCalendarMultiple';
import { useCalendarOpenState } from './hooks/useCalendarOpenState';
import { useCalendarDisplayValue } from './hooks/useCalendarDisplayValue';
import { CalendarInputPropsType } from './types';

export const CalendarInput: React.FC<CalendarInputPropsType & { props?: Record<string, unknown> }> = props => {
  const multiple = useCalendarMultiple();
  const [openState, toggleOpenState] = useCalendarOpenState();
  const [value, setValue] = useCalendarValue();
  const displayValue = useCalendarDisplayValue();

  const Component = props.component;

  return React.useMemo(() => (<Component
    value={value}
    displayValue={displayValue}
    open={openState}
    multiple={multiple}
    onChange={setValue}
    onToggleOpenState={toggleOpenState}
    {...props.props}
  />), [JSON.stringify(displayValue), multiple, openState, JSON.stringify(value), props.props]);
}
